function AboveTheFold() {
	return (
		<div className="above-the-fold">
			<div className="one-line">
				Change your life and expand your career options
			</div>
			<p>
				Liskov is a new tech bootcamp in Melbourne that gives you the
				opportunity to enter the world of tech in 6-months
			</p>
			<div className="heading-three-points">
				{`> Owned and run by developers`}
			</div>
			<div className="explanation-three-points">
				We are in the industry.
				<p>
					🌏 The Liskov team are working in some of Melbourne's biggest dev
					houses
				</p>
				<p>
					🌎 Our teachers are experienced. All our teachers and assistants have
					taught in coding bootcamps
				</p>
				<p>
					🌍 Liskov will change Melbourne's coding bootcamp space. We understand
					where you are now and where you need be. Our passion, experience and
					knowledge means we know exactly how to get you there
				</p>
			</div>
			<div className="heading-three-points">{`> Integrated course`}</div>
			<div className="explanation-three-points">
				We are building a community. We will:
				<p>👾 Produce the best junior engineers in Melbourne</p>
				<p>
					👾 Have the best, most up-to-date course structure, and points of
					crossover between the courses
				</p>
				<p>👾 Employ the best and most motivated teachers</p>
				<p>
					👾 Provide you with real world experience through project-based
					learning
				</p>
				<p>
					👾 Give you a direct line to Everest Engineering, one of Melbourne's
					largest consultancies
				</p>
				Our number one job is to find you a job.
			</div>
			<div className="heading-three-points">
				{`> Full time teacher support`}
			</div>
			<div className="explanation-three-points">
				Our teachers will be there for you full-time and in-person. And though
				we offer flexible delivery we will have a physical space for you to come
				to. Our philosophy is that:
				<p>👨🏼‍🏫 The best teaching happens in-person</p>
				<p>
					👨🏼‍🏫 The best learning happens through collaboration with your fellow
					students
				</p>
				With our support you will be ready to take on the world. We are also
				open to flexibility, and the course is designed to give you options to
				fit your life around it.
			</div>
		</div>
	);
}

export default AboveTheFold;
